@defer (when organizer) {
  <app-modal-header (closeModal)="close()" />
  <app-modal-body>
    <h1 class="fw-medium fs-5">
      <i class="ri-double-quotes-l"></i>
      {{ organizer?.title }}
    </h1>
    <p class="mb-0">{{ organizer?.desc }}</p>
  </app-modal-body>
  <app-modal-footer classList="d-flex flex-column justify-content-center">
    <div class="d-flex justify-content-center gap-2">
      @if (organizer?.url) {
        <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="openUrl()">
          <i class="ri-external-link-line"></i>
          {{ 'OPEN_URL' | translate }}
        </button>
      }
      <button type="button" class="btn rounded-5 btn-outline-dark" (click)="close()">
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </app-modal-footer>
} @placeholder {
  @if (isShowPlaceholder) {
    <app-modal-body>
      <div class="d-flex flex-column mt-5">
        @for (item of [].constructor(3); track $index) {
          <ngx-skeleton-loader
            [theme]="{
              width: '100%',
              height: '30px',
            }"
          />
        }
      </div>
    </app-modal-body>
  }
}
